module.exports = __webpack_public_path__ + "img/site-preview.30242613.png";